import React from 'react';
import { storesContext } from '../context';
export var useStores = function useStores() {
    return React.useContext(storesContext);
};
